/**
 * Upload a file using the "ticket" returned by the backend.
 * Works for both providers (the backend decides via STORAGE_PROVIDER):
 *   - S3:         PUT raw file to ticket.url
 *   - Cloudinary: POST multipart form (ticket.fields + file) to ticket.url
 * Returns the fetch Response so callers can keep using `.ok`.
 */
export const uploadWithTicket = (ticket, file) => {
  if (ticket.method === "POST" && ticket.fields) {
    const form = new FormData();
    Object.entries(ticket.fields).forEach(([k, v]) => form.append(k, v));
    form.append("file", file);
    return fetch(ticket.url, { method: "POST", body: form });
  }
  return fetch(ticket.url, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
};
